import { render, staticRenderFns } from "./TeamReward.vue?vue&type=template&id=221c847d&scoped=true&"
import script from "./TeamReward.vue?vue&type=script&lang=js&"
export * from "./TeamReward.vue?vue&type=script&lang=js&"
import style0 from "./TeamReward.vue?vue&type=style&index=0&id=221c847d&prod&lang=scss&scoped=true&"
import style1 from "./TeamReward.vue?vue&type=style&index=1&id=221c847d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c847d",
  null
  
)

export default component.exports